module.exports = __webpack_public_path__ + "img/am.3367445d.svg";